import { tw } from "@careinfo/tailwind";
import { CellContext, ColumnDef } from "@tanstack/react-table";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import APIS from "../../constant/Endpoint";
import Button from "../../shared/Button";
import DataTable from "../../shared/DataTable";
import ActionCell from "../../shared/DataTable/ActionCell";
import NACell from "../../shared/DataTable/NACell";
import Modal from "../../shared/Modal";
import SwitchButton from "../../shared/Switch";
import { IPage } from "../../types/interface";

interface Props {
  showDeleteModal: boolean;
  setShowDeleteModal: Dispatch<SetStateAction<boolean>>;
  handleDelete: (id: string) => Promise<void>;
  isDeletingPage: boolean;
  isUpdatignPage: boolean;
  handlePublic: (value: boolean, id: string) => Promise<void>;
}

export default function PagesList({
  showDeleteModal,
  setShowDeleteModal,
  handleDelete,
  isDeletingPage,
  isUpdatignPage,
  handlePublic,
}: Props) {
  const [toDelete, setToDelete] = useState<string | null>(null);

  const handleDeleteClick = (id: string) => {
    setToDelete(id);
    setShowDeleteModal(true);
  };

  const handleModalClose = () => {
    setToDelete(null);
    setShowDeleteModal(false);
  };

  const columns: ColumnDef<IPage>[] = [
    {
      accessorKey: "title",
      header: "Title",
      cell: NACell,
    },
    {
      accessorKey: "is_published",
      header: "Published",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <SwitchButton
              value={getValue()}
              onChange={(value: boolean) =>
                handlePublic(value, row.original.id)
              }
              disabled={isUpdatignPage}
            />
          </>
        );
      },
    },
    {
      accessorKey: "slug",
      header: "Slug",
      cell: NACell,
    },
    {
      header: "Action",
      accessorKey: "id",
      cell: (props: CellContext<any, string>) => (
        <ActionCell
          {...props}
          editPath={`edit/${props.getValue()}`}
          handleDeleteClick={handleDeleteClick}
        />
      ),
    },
  ];

  useEffect(() => {
    if (!showDeleteModal) setToDelete(null);
  }, [showDeleteModal]);

  return (
    <div>
      <DataTable
        url={`${APIS.PAGE}`}
        queryKey="pages"
        columns={columns}
        addNewPagePath="create"
        tableName="pages"
      />

      <Modal
        isOpen={showDeleteModal}
        setIsOpen={setShowDeleteModal}
        closeModal={handleModalClose}
        title="Are you sure, want to delete this component?"
        width="20rem"
      >
        <Modal.Caution>
          <p className={tw`py-2`}>
            <span className={tw`font-bold text-primary text-center`}>
              Note:{"    "}
            </span>
            This action can not be undone
          </p>
        </Modal.Caution>
        <div className={tw`grid grid-cols-2 gap-x-4 items-center`}>
          <Button
            label="Yes, Delete"
            type="button"
            onClick={() => handleDelete(toDelete)}
            isLoading={isDeletingPage}
            disabled={isDeletingPage || !toDelete}
          />
          <button
            type="button"
            onClick={() => {
              setToDelete(null);
              setShowDeleteModal(false);
            }}
            className={tw`w-full bg-gray-400 text-white px-4 py-2 rounded-md focus:outline-none`}
          >
            Cancel
          </button>
        </div>
      </Modal>
    </div>
  );
}
